import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NoteTable from "../../common_nextgen/common_components/NoteScreenComponents/NoteTable";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import useDeductibleScheduleNotes from "./hooks/useDeductibleScheduleNotes";
import "./css/DeductibleScheduleNote.css";
import {
  PRICE_SCHEDULE_MODES,
  ROUTE_PATHS,
} from "../../common_nextgen/utils/Constants";

const DeductibleScheduleNote = () => {
  const location = useLocation();
  const {
    DEDUCTIBLE_SCHEDULE,
    EDIT_DEDUCTIBLE_SCHEDULE,
    DISPLAY_DEDUCTIBLE_SCHEDULE,
  } = ROUTE_PATHS;
  const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);
  const {
    selectedSchedules = [],
    previousScreen = DEDUCTIBLE_SCHEDULE,
    currentIndex: initialIndex = 0,
    currentMode,
  } = currentState;
  console.log("sel sch", selectedSchedules);
  const navigateToPage = useCustomNavigate();

  const {
    notes,
    newNotes,
    mode,
    first,
    rows,
    totalRecords,
    currentIndex,
    setMode,
    setFirst,
    setRows,
    setCurrentIndex,
    handleSaveNotes,
    handleChangeNewNote,
    onPageChange,
    exportAsCSV,
  } = useDeductibleScheduleNotes(selectedSchedules, initialIndex, currentMode);

  const screen_title = "Deductible Schedule Note";
  const screen_code = "RCDSN001";

  const columns =
    mode === "view"
      ? [
          { key: "dsnNote", header: "Note" },
          { key: "chgDate", header: "Added Date" },
          { key: "chgTime", header: "Added Time" },
          { key: "chgUserName", header: "User" },
        ]
      : [{ key: "dsnNote", header: "Note" }];

  useEffect(() => {
    if (currentIndex != initialIndex) {
      setParamsData({
        dscScheduleName: selectedSchedules[currentIndex].dscScheduleName,
        dscDescription: selectedSchedules[currentIndex].dscDescription,
      });
    }
    
  }, [currentIndex]);

  const handleBack = useCallback(() => {
    if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  }, [currentIndex, navigateToPage, setCurrentIndex]);

  const handleBackAndSetMode = useCallback(() => {
    handleBack();
    setMode("view");
  }, [handleBack, setMode]);

  function handleModeSwitch() {
    if (mode === "add") {
      setMode("view");
    } else if (mode === "view") {
      setMode("add");
    }
  }

  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: handleBackAndSetMode,
      button_key: "F12",
    },
    ...(mode === "add"
      ? [
          {
            button_label: "View Note",
            button_handeler: handleModeSwitch,
            button_key: "F6",
          },
        ]
      : []),
  ];

  const rightButtons = [
    ...(mode === "view"
      ? [
          {
            button_label: "Add Note",
            button_handeler: handleModeSwitch,
            button_key: "F6",
          },
        ]
      : []),
    { button_label: "Export as CSV", button_handeler: exportAsCSV },
  ];

  const [paramsData, setParamsData] = useState({
    dscScheduleName: selectedSchedules[currentIndex].dscScheduleName,
  });

  const getName = (selectedSchedules, currentIndex) => (
    <>
      <span className="info-records">
        <strong>Schedule </strong>
        {selectedSchedules[currentIndex].dscScheduleName}
      </span>
      <span className="info-records">
        <strong>Description </strong>
        {selectedSchedules[currentIndex].dscDescription}{" "}
        {/* Show the description */}
      </span>
    </>
  );

  return (
    <div className="container">
      <ButtonsSection ctaButtons={leftButtons} align="left" />
      <div className="left-aligned-section">
        <div className="header-section">
          <h1>
            {screen_title} - <span className="heading-cod">{screen_code}</span>
          </h1>
        </div>
        <p className="head-name">{getName(selectedSchedules, currentIndex)}</p>
      </div>
      <div className="button-sections">
        <ButtonsSection ctaButtons={rightButtons} align="right" />
      </div>
      <NoteTable
        data={notes}
        columns={columns}
        mode={mode}
        newNotes={newNotes}
        handleChangeNewNote={handleChangeNewNote}
        handleSaveNotes={handleSaveNotes}
      />
      <NextGenPaginator
        first={first}
        rows={rows}
        totalRecords={totalRecords}
        currentPage={first / rows}
        rowsPerPageOptions={[10, 25, 50]}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default DeductibleScheduleNote;
